import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import currencyJs from "currency.js";
import React from "react";
import { getCurrency } from "../../../../hooks";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import styles from "./TripBuilderQuoteStep.module.scss";

export const QuoteGroupsIncludedExcursions: React.FC = () => {
    const { gcDeparture } = useTripBuilder();
    const { draftQuote } = useTripBuilderQuote();
    const { productPage } = useI18n("productPage");
    const { formatCurrency } = getCurrency();
    const hasGcDeparture = !!gcDeparture;

    if (
        !hasGcDeparture ||
        !draftQuote ||
        draftQuote.order.trips[0].openExcursionLineItems.length === 0
    ) {
        return null;
    }

    const includedExcursionPrices = draftQuote.order.trips.flatMap((trip) =>
        trip.openExcursionLineItems.map((excursion) => excursion.price.value),
    );
    const totalPrice = includedExcursionPrices.reduce(
        (acc, curr) => acc.add(curr),
        currencyJs(0),
    ).value;

    return (
        <div className={styles.configurations}>
            <div className={styles["value-group"]}>
                <Text.Heading order="6" emphasis="2" tag="p">
                    {productPage.tripBuilder.quote.excursions.heading.l()}
                </Text.Heading>
                <Text.Heading order="6" tag="p">
                    {formatCurrency(totalPrice)}
                </Text.Heading>
                <Text.Body>
                    {productPage.tripBuilder.quote.excursions.includedByGroupCoordinator.l()}
                </Text.Body>
            </div>
        </div>
    );
};
